'use strict';

angular.module('licensure.services')
    .factory('ServiceUserLongevities', ['$http', '$q', function ($http, $q) {
        var save = function (service_user_longevity) {
            var d = $q.defer();

            var method = 'POST';
            var url = apiLocation + '/api/ServiceUserLongevities/';
            if (!isUndefined(service_user_longevity.id)) {
                method = 'PUT'
                url += service_user_longevity.id
            }

            $http({
                method: method,
                url: url,
                data: {
                    service_user_longevity: service_user_longevity
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        return {
            get: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ServiceUserLongevities', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ServiceUserLongevities/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getCount: function (args) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/ServiceUserLongevities/GetCount', {
                        params: args
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: save,

            delete: function (id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + '/api/ServiceUserLongevities/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            manualRedemption: function (userID) {
                var d = $q.defer();

                $http
                    .post(apiLocation + '/api/ServiceUserLongevities/ManualRedemption', {
                        user_id: userID
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            saveElement: function (answers, licenseRequestID) {
                var d = $q.defer();
                var longevities = [];

                answers.forEach(function (answer) {
                    if (answer.license_request_id != null && answer.service_id != null && answer.user_id != null && answer.approve) {
                        var saveAnswer = angular.copy(answer);
                        longevities.push(saveAnswer);
                    }
                });

                $http({
                    method: 'POST',
                    url: apiLocation + '/api/ServiceUserLongevities/saveElement',
                    data: {
                        service_user_longevities: longevities,
                        license_request_id: licenseRequestID
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        console.log(response.data);
                    });

                return d.promise;
            }
        }
    }])
;